import { ofType } from "redux-observable";
import { map, retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionCoopPointsInfoResponse, TypeActionCoopInfo, } from "../actionCoop";
export var epicCoopPointsInfoRequest = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionCoopInfo.CoopPointsInfoRequest), switchMap(function (action) {
        return deps.netSend({
            id: CommandCode.CoopPointsInfo,
            props: {
                coopId: action.coopId,
                playerId: action.playerId,
            },
        });
    }), map(actionCoopPointsInfoResponse), retry());
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/epic/epicCoopPointsInfoRequest.ts
// module id = 1818
// module chunks = 3